import { FC } from "react"
import { BlankStateSection } from "src/components/shared/BlankStateSection"
import { CenteredSpinner } from "src/components/shared/CenteredSpinner"
import { IHallBooking } from "src/domain/entities"
import { HallBookingListView } from "."

interface Props {
	list: IHallBooking[]
	isLoading: boolean
	onUpdate: (item: IHallBooking) => void
	onDelete: (item: IHallBooking) => void
	onAddBill: (item: IHallBooking) => void
	onAddClick: () => void
	onViewBill: (item: IHallBooking) => void
}

export const HallBookingListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddBill,
	onAddClick,
	onViewBill,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return <BlankStateSection message="No items found." onAddClick={onAddClick} />
	}

	return (
		<HallBookingListView
			list={list}
			onUpdate={onUpdate}
			onDelete={onDelete}
			onAddBill={onAddBill}
			onViewBill={onViewBill}
		/>
	)
}
